import { render, staticRenderFns } from "./TopNavbar2.vue?vue&type=template&id=a9d7a99c"
import script from "./TopNavbar2.vue?vue&type=script&lang=js"
export * from "./TopNavbar2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports